import React, { useEffect, useState } from "react";
import SystemCertificateForm from "./SystemCertificateForm";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/systemCertificateActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';
import config from '../../../config/config';
import { makeTranslates } from './utils';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const SystemCertificateEdit = props => {
    const { classes, systemCertificate, loading, onFetchSystemCertificate, onFetchProductType, onFetchSystemCertificateInit, activeCustomerID, translations, permissions, onEditSystemCertificate } = props;

    const [productTypes, setProductTypes] = useState([]);
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '', imageValue: null, data: true, valid: true });

    useEffect(() => {
        const fetchData = async () => {
            await onFetchSystemCertificate({ ActiveCustomerID: activeCustomerID, SystemCertificateID: parseURL(window.location.href).SystemCertificateID });
        }
        const fetchProductTypes = async () => {
            let productTypesList = await onFetchProductType({ ActiveCustomerID: activeCustomerID });
            setProductTypes(productTypesList);
        }
        if (productTypes?.length <= 0) {
            fetchProductTypes();
        }
        fetchData();
        return () => {
            onFetchSystemCertificateInit();
        }
    }, [activeCustomerID, onFetchProductType, onFetchSystemCertificate, onFetchSystemCertificateInit, productTypes]);

    useEffect(() => {
        if (systemCertificate) {
            let imageName = systemCertificate.FilePath.split('/').pop();
            setFileToSend({ ...fileToSend, data: false, imageValue: systemCertificate && systemCertificate.FilePath ? `${config.backend_domain}:${config.backend_port}/static/${imageName}` : '' });
        }
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [systemCertificate]);

    const handleSubmit = async data => {

        const formData = new FormData();

        formData.append("ActiveCustomerID", activeCustomerID);
        formData.append("SystemCertificateID", systemCertificate?.SystemCertificateID);
        formData.append("Name", data?.Name);
        formData.append("Type", data?.Type);

        let productTypeIDs = Array.from(new Set(data?.ProductTypes.map(el => el.value)));

        formData.append("ProductTypes", JSON.stringify(productTypeIDs));

        let token = localStorage.getItem("SESSION");

        formData.append("Token", token);

        let result = await onEditSystemCertificate(formData);

        if (result) {
            History.goBack()
        }
    };
    const productTypesWithTranslations = (productTypes ?? []).map(el => ({
        'value': el.value,
        'name': el.key,
        'label': makeTranslates(el.key + "")
    }));

    let initials = (systemCertificate?.ProductTypes ?? []).map(el => ({
        'value': el.ProductTypeID,
        'name': el.Key,
        'label': makeTranslates(el.Key + "")
    }));

    let initialValues = {
        Name: systemCertificate?.Name || "",
        Type: systemCertificate?.Type || "",
        ProductTypes: initials || []
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Type: Yup.string().required("Required"),
            ProductTypes: Yup.array().required("Required")
        },
        FormTitle: translations["system_certificate_edit"] || "Edit system certificate",
        ButtonSubmit: hasPermission(permissions, 'system_certificate_save')
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={loading}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!loading ?
                <SystemCertificateForm
                    productTypes={productTypesWithTranslations}
                    edit={true}
                    formSettings={formSettings}
                    imageValue={fileToSend?.imageValue}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                />
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID || null,
        permissions: state?.core?.login?.permissions || [],
        systemCertificate: state?.admin?.systemCertificate?.loaded || null,
        loading: state?.admin?.systemCertificate?.loading || false,
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchSystemCertificateInit: systemCertificate => dispatch(actions.loadSystemCertificateInit(systemCertificate)),
        onFetchSystemCertificate: systemCertificate => dispatch(actions.loadSystemCertificate(systemCertificate)),
        onEditSystemCertificate: systemCertificate => dispatch(actions.editSystemCertificate(systemCertificate)),
        onFetchProductType: params => dispatch(actions.listProductTypes(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(SystemCertificateEdit));
